// extracted by mini-css-extract-plugin
module.exports = {"main_color":"#009ccc","container":"CommentFormButton-module--container--1HcgZ","icon":"CommentFormButton-module--icon--2VU_w"};